import { useIntl } from "react-intl";
import type { FieldOption } from "@/lib/field-util";
import { DegreeSelect } from "./DegreeSelect";
import { InfoTooltip } from "./InfoTooltip";

export function DegreeRequirementSelect({
  value,
  onChange,
  options,
  readOnly = false,
}: {
  value: string;
  onChange: (next: string) => void;
  options: readonly FieldOption[];
  readOnly?: boolean;
}) {
  const intl = useIntl();
  const selectedOrLegacyOptions =
    value && !options.some((option) => option.value === value)
      ? [{ value, label: value }, ...options]
      : options;

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      <DegreeSelect
        value={value}
        onChange={onChange}
        options={selectedOrLegacyOptions}
        editable={!readOnly}
        disabled={readOnly}
        required
        variant="plain"
        className="w-48 max-w-full"
        placeholder={intl.formatMessage({
          id: "match.recruiting.educationDegreePlaceholder",
          defaultMessage: "Select degree",
        })}
        ariaLabel={intl.formatMessage({
          id: "match.recruiting.educationDegreeLabel",
          defaultMessage: "Required degree",
        })}
      />
      <InfoTooltip
        ariaLabel={intl.formatMessage({
          id: "match.recruiting.educationLevelInfo.aria",
          defaultMessage: "Explain AI degree evaluation",
        })}
        title={intl.formatMessage({
          id: "match.recruiting.educationLevelInfo.title",
          defaultMessage: "Degree evaluation",
        })}
        placement="top"
        contentClassName="max-w-xs"
      >
        {intl.formatMessage({
          id: "match.recruiting.educationLevelInfo.body",
          defaultMessage:
            "Without AI, the selected catalogue entry is compared directly. With AI enabled, the model is instructed to also consider equivalent or clearly higher formal qualifications.",
        })}
      </InfoTooltip>
    </div>
  );
}
